<div class="flex flex-col gap-2">
    <!--   logo section-->
    <div class="avatar items-start" *ngIf="(logo$ | ngrxPush)?.loading">
        <div class="spinner spinner-primary {{ avatarClasses }}"></div>
    </div>

    <div class="avatar items-start" *ngIf="(logo$ | ngrxPush)?.url && !(logo$ | ngrxPush)?.loading">
        <div class="{{ avatarClasses }} rounded-lg border border-base-200">
            <img [src]="(logo$ | ngrxPush)?.url" class="!object-contain" />
        </div>
        <button
            *ngIf="enableEditLogo"
            (click)="openCompanyLogoDialog(false)"
            class="pt-1 transition-opacity w-full duration-150 border-2 border-base-200 text-white opacity-0 hover:opacity-100 absolute backdrop-blur-sm bg-black bg-opacity-25 h-full rounded-lg shadow-xl"
        >
            <iota-icon icon="camera" size="2"></iota-icon>
        </button>
    </div>
    <div class="avatar placeholder items-start" *ngIf="!(logo$ | ngrxPush)?.url && !(logo$ | ngrxPush)?.loading">
        <button
            *ngIf="enableEditLogo"
            (click)="openCompanyLogoDialog(false)"
            class="pt-1 transition-opacity w-full duration-150 border-2 border-base-200 text-white opacity-0 hover:opacity-100 absolute backdrop-blur-sm bg-black bg-opacity-25 h-full rounded-lg shadow-xl"
        >
            <iota-icon icon="camera" size="2"></iota-icon>
        </button>
        <div class="{{ avatarClasses }} rounded-lg border border-base-200 bg-neutral text-neutral-content">
            <span class="uppercase">{{ initials$ | ngrxPush }}</span>
        </div>
    </div>

    <!--   Extra logo section-->
    <div class="avatar items-start" *ngIf="(logoExtra$ | ngrxPush)?.loading">
        <div class="spinner spinner-primary {{ avatarClasses }}"></div>
    </div>

    <div
        class="avatar items-start bg-neutral bg-opacity-20 rounded-lg"
        *ngIf="(logoExtra$ | ngrxPush)?.url && !(logoExtra$ | ngrxPush)?.loading"
    >
        <div class="{{ avatarClasses }} rounded-lg border border-base-200">
            <img [src]="(logoExtra$ | ngrxPush)?.url" class="!object-contain" />
        </div>
        <button
            *ngIf="enableEditLogo"
            (click)="openCompanyLogoDialog(true)"
            class="pt-1 transition-opacity w-full duration-150 border-2 border-base-200 text-white opacity-0 hover:opacity-100 absolute backdrop-blur-sm bg-black bg-opacity-25 h-full rounded-lg shadow-xl"
        >
            <iota-icon icon="camera" size="2"></iota-icon>
        </button>
    </div>
    <div class="avatar placeholder items-start" *ngIf="!(logoExtra$ | ngrxPush)?.url && !(logoExtra$ | ngrxPush)?.loading">
        <button
            *ngIf="enableEditLogo"
            (click)="openCompanyLogoDialog(true)"
            class="pt-1 transition-opacity w-full duration-150 border-2 border-base-200 text-white opacity-0 hover:opacity-100 absolute backdrop-blur-sm bg-black bg-opacity-25 h-full rounded-lg shadow-xl"
        >
            <iota-icon icon="camera" size="2"></iota-icon>
        </button>
        <div class="{{ avatarClasses }} rounded-lg border border-base-200 bg-neutral text-neutral-content">
            <span class="uppercase">{{ initials$ | ngrxPush }}</span>
        </div>
    </div>
</div>
